import {FIELD_TYPE} from "types/enums";
import React from "react";
const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Tên user",
    name: "name",
  },
  {
    type: COMBO_BOX,
    label: "Role",
    name: "role",
  },
];
const columns: any[] = [
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Tên",
    dataIndex: "lastName",
    key: "lastName",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Họ",
    dataIndex: "firstName",
    key: "firstName",
    show: true,
    isResizable: true,
    align: "left",
  },
  // {
  //   title: "Chi nhánh",
  //   dataIndex: "chiNhanh",
  //   key: "chiNhanh",
  //   show: true,
  //   isResizable: true,
  //   align: "left",
  // },
  // {
  //   title: "Kho",
  //   dataIndex: "kho",
  //   key: "kho",
  //   show: true,
  //   isResizable: true,
  //   align: "left",
  // },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "enabled",
    key: "enabled",
    show: true,
    isResizable: true,
    align: "left",
    render: (v, r, i) => {
      return <>{v ? "Hoạt động" : "Dừng hoạt động"}</>;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    isResizable: true,
    align: "center",
  },
];

export {fields, columns};
